import ImageCell from './ImageCell';

export default ImageCell;
